import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, Typography } from "@mui/material";

const InfoTile = (props) => {
    const { title = '', info = '' } = props;
    const theme = useTheme();

    return (
        <Card variant="outlined" sx={{ padding: '2%' }}>
            <CardContent className="tile-cards">
                <Typography color="text.secondary">
                    {title}
                </Typography>
                <Typography
                    color={theme.palette.primary['A700']}
                    sx={{ fontSize: 40, fontWeight: 500, marginTop: "2%" }}
                >
                    {info}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default InfoTile;